import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { closeNotifyAboutNewVersionModalAction } from "store/modals/reducer.actions";
import { useDispatch } from "react-redux";
import Button from "view/components/Button";
import moment from "moment";
import apiClient from "services/apiClient";
const style: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  // width: auto,
  backgroundColor: "#ffff",
};
const reactVersioningEndpoint = process.env.REACT_APP_VERSIONING_ENDPOINT || "";

interface NotifyAboutNewVersionModalProps {}

export const NotifyAboutNewVersionModal: React.FC<
  NotifyAboutNewVersionModalProps
> = () => {
  const { notifyAboutNewVersionModal } = useSelector(
    (state: RootState) => state.modals
  );
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    dispatch(closeNotifyAboutNewVersionModalAction());
  };

  const refreshAndClearForUpdate = async () => {
    setIsLoading(true);

    try {
      localStorage.removeItem("lastUpdateDismissed");
      const { data } = await fetchReactVersion();

      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cache) => caches.delete(cache)));
        console.log("Caches have been cleared!");
      }
      localStorage.setItem("appVersion", data.react);

      handleClose();
      window.location.reload();
    } catch (error) {
      console.error("Failed to refresh and clear for update:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const markUpdateAsDismissed = () => {
    const currentTime = moment().valueOf();
    localStorage.setItem("lastUpdateDismissed", currentTime.toString());
    handleClose();
  };
  const isReminder = shouldShowReminderMessage();
  return (
    <Modal
      open={notifyAboutNewVersionModal?.isOpen}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      disableAutoFocus={true}
      aria-describedby="modal-modal-description"
      className="border-none"
    >
      <Box sx={style} className="dark:bg-secondaryLight ">
        <div className="flex flex-col justify-start items-start w-[480px] rounded-lg">
          <div
            className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 p-6 rounded-lg dark:bg-secondaryLight bg-bgWhite"
            style={{
              boxShadow:
                "0px 2px 8px 0 rgba(2,13,36,0.1), 0px 2px 24px 0 rgba(2,13,36,0.08)",
            }}
          >
            <div className="flex  justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
              <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
                <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain">
                  {isReminder
                    ? "Reminder: Update Available"
                    : " Update Available"}
                </p>
              </div>
              <button onClick={markUpdateAsDismissed} type="button">
                <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
              </button>
            </div>
            <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
              <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-caption">
                {isReminder
                  ? "A new version is available for you to use! Refresh the application to enjoy the latest features and enhancements for the best experience."
                  : " A new version is available for you to use! Please refresh the application to update."}
              </p>
            </div>

            <div className="flex items-center self-stretch justify-end flex-grow-0 flex-shrink-0 gap-2">
              <Button
                type="button"
                text="Cancel"
                filledColor="primary"
                outlinedColor="primary"
                textColor="textWhite"
                className="px-5 py-2"
                width="35"
                height="13"
                fontStyle="font-semibold"
                variant="outlined"
                onClick={markUpdateAsDismissed}
              />

              <Button
                disabled={isLoading}
                type="button"
                text={"Refresh"}
                filledColor="primary"
                outlinedColor="primary"
                textColor="textWhite"
                className="px-5 py-2"
                width="35"
                height="13"
                fontStyle="font-semibold"
                variant="filled"
                onClick={refreshAndClearForUpdate}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

function shouldShowReminderMessage() {
  const lastUpdateDismissed: any = localStorage.getItem("lastUpdateDismissed");
  if (!lastUpdateDismissed) {
    return false;
  }
  const lastUpdateDismissedMoment = moment(parseInt(lastUpdateDismissed));
  const hoursSinceDismissed = moment().diff(lastUpdateDismissedMoment, "hours");

  return hoursSinceDismissed >= 1;
}

async function fetchReactVersion() {
  try {
    const response = await apiClient.get(reactVersioningEndpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching React version:", error);
    throw error;
  }
}
